<template>
    <div
        class="font-sans-rubik fixed flex flex-col bg-menu-white300 dark:bg-menu-black370 h-full transition-width"
        :class="[
            mini ? 'w-side-bar-main-mini' : 'w-side-bar-main',
            showMobileSideBars ? 'z-100' : '-left-offset-side-bar-main min-mb:left-0',
        ]"
        :style="{ 'max-height': `calc(100vh - ${maintenanceModeHeight}px)` }"
        v-touch:swipe.left="onSwipeLeft"
    >
        <div class="shrink-0">
            <div class="h-app-bar flex items-center">
                <SideBarWorkspaceMenu
                    class="w-full pl-2 pr-4"
                    :mini="mini"
                    :isOwner="isOwner"
                    @onChange="onChangeMini"
                />
            </div>

            <div
                class="border-t border-gray-100 dark:border-gray-760"
                :class="mini ? 'mx-2' : 'mx-4'"
            ></div>

            <div
                v-if="mini && !isMbView"
                class="flex group w-6 h-6 mx-auto my-2 items-center justify-center rounded-1.25 hover:bg-menu-purple70 dark:hover:bg-menu-blue770 cursor-pointer"
                @click="onChangeMini"
            >
                <DoubleArrowIcon class="text-gray-600 dark:text-gray-600 dark:group-hover:text-gray-200" />
            </div>
        </div>

        <div
            class="flex-1 min-h-0 custom-scroll-y"
            :class="bottomPadding"
        >
            <slot />
        </div>

        <div class="shrink-0 py-1 border-t border-gray-100 dark:border-gray-760">
            <SideBarAccountMenu :mini="mini" />
        </div>
    </div>
</template>

<script setup>
import { computed, inject } from 'vue'

import SideBarWorkspaceMenu from '@/components/navigation/SideBar/SideBarWorkspaceMenu.vue'
import SideBarAccountMenu from '@/components/navigation/SideBar/SideBarAccountMenu.vue'
import DoubleArrowIcon from '@/components/icons/arrow/DoubleArrowIcon.vue'

import { useAppStore } from '@/store/appStore'
import { useAuthorizationStore } from '@/store/authorizationStore'

import { MAINTENANCE_MODE_STATUS } from '@/constants/maintenanceMode'
import { viewPorts } from '@/constants/viewPorts'

const props = defineProps({
    mini: {
        type: Boolean,
        default: false,
    },
    showMobileSideBars: {
        type: Boolean,
        default: false,
    },
    withBottomPadding: {
        type: Boolean,
        default: false,
    },
    maintenanceModeHeight: {
        type: Number,
        default: 0,
    },
})

const emits = defineEmits(['update:mini', 'swipeLeft'])

const appStore = useAppStore()
const authorizationStore = useAuthorizationStore()

const currentViewSize = inject('currentViewSize')

const isOwner = computed(() => authorizationStore.isOwner)

const isMbView = computed(() => viewPorts.mb >= currentViewSize.value)

const maintenanceModeShow = computed(() => appStore.maintenanceMode === MAINTENANCE_MODE_STATUS.active)

const bottomPadding = computed(() => {
    if (!props.withBottomPadding) {
        return ''
    }

    return maintenanceModeShow.value ? 'pb-4' : 'pb-2'
})

function onChangeMini() {
    emits('update:mini', !props.mini)
}

function onSwipeLeft() {
    emits('swipeLeft')
}
</script>
